export const visit = (vm, at) => {
at({ "en": { "priceComponents": { "pricePerMonth": "{{price}}/mo", "pricePerMonthPerSeat": "{{price}}/mo/seat", "subtexts": { "startsAt": "Starts at" } } } });
};